import React from 'react';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

export default function BackHomeButton() {
  const history = useHistory();

  return (
    <Button
      onClick={() => history.push('/home')}
      variant="outlined"
      size="small"
      sx={{
        position: 'fixed',
        top: 16,
        left: 16,
        zIndex: 1300,
        color: 'orange',
        borderColor: 'orange',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: 'orange',
        },
      }}
    >
      ← Voltar
    </Button>
  );
}
